import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenAwalBayiBaruLahir";

interface AsesmenBBLData {
  id: number;
  register_id: number;
  pasien_rm: string;
  unit_id: string;
  examined_at: string;
  // Link ibu -> bayi
  ibu_register_id: number;
  ibu_pasien_rm: string;
  // Identitas & status kelahiran
  jam_lahir: string;
  jenis_kelahiran: string;
  urutan_kembar: number;
  status_bayi: string;
  deceased_at: string;
  sikap_bayi: string;
  nadi: number;
  suhu: number;
  pernapasan: number;
  // Antropometri lahir
  berat_lahir_gram: number;
  panjang_badan_cm: number;
  lingkar_kepala_cm: number;
  lingkar_dada_cm: number;
  // Usia kehamilan & klasifikasi
  usia_kehamilan_minggu: number;
  usia_kehamilan_hari: number;
  klasifikasi_gestasi: string;
  klasifikasi_berat: string;
  klasifikasi_bb_uk: string;
  // APGAR
  apgar_1: number;
  apgar_5: number;
  apgar_10: number;
  apgar_interpretasi: string;
  // Flag laporan
  resusitasi_dilakukan: boolean;
  // Dubowitz
  dubowitz_neuro_total: number;
  dubowitz_fisik_total: number;
  dubowitz_total: number;
  taksiran_umur_kehamilan: number;
  content: any;
  diagnosis: string;
  rencana_tindakan: string;
  dokter_id: number;
  signed_dokter: boolean;
  creator_user_id?: number | null;
  signed_dokter_at: string;
  dokter: any;
  ppja_id: number;
  signed_ppja: boolean;
  signed_ppja_at: string;
  ppja: any;
  pasien: any;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-awal-bayi-baru-lahir"
})
class AsesmenAwalBayiBaruLahirStore extends VuexModule {
  loading = false;
  asesmen: AsesmenBBLData = null;

  @Mutation
  SET_RECORD(val) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.asesmen = null;
    this.loading = false;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_RECORD(response.data?.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(AsesmenAwalBayiBaruLahirStore);
